export default function ConsultationPricing() {
  return (
    <section id="consulta" className="py-20 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Reserva tu Consulta Online
            </h2>
            <p className="text-xl text-blue-100">
              Selecciona la modalidad que necesites
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white rounded-2xl shadow-2xl p-8 hover:scale-105 transition-transform">
              <div className="text-center mb-6">
                <div className="w-20 h-20 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-4">
                  <i className="ri-calendar-check-line text-4xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  Consulta Normal
                </h3>
                <p className="text-gray-600 mb-4">Respuesta en 24h</p>
                <div className="text-5xl font-bold text-blue-600 mb-2">
                  80 <span className="text-2xl">USD</span>
                </div>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Evaluación de elegibilidad</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Estrategia personalizada</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Checklist de documentos</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Zoom 45-60 min</span>
                </li>
              </ul>
              <a 
                href="https://calendly.com/abogado-extranjeria/video_consulta_no_urgente?back=1&month=2025-11" 
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-blue-600 text-white py-4 rounded-lg font-bold text-lg hover:bg-blue-700 transition-all text-center whitespace-nowrap cursor-pointer"
              >
                Reservar Ahora
              </a>
            </div>

            <div className="bg-white rounded-2xl shadow-2xl p-8 border-4 border-yellow-400 hover:scale-105 transition-transform relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-yellow-400 text-gray-900 px-4 py-1 rounded-full text-sm font-bold">
                  MÁS POPULAR
                </span>
              </div>
              <div className="text-center mb-6">
                <div className="w-20 h-20 flex items-center justify-center bg-yellow-100 rounded-full mx-auto mb-4">
                  <i className="ri-flashlight-fill text-4xl text-yellow-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  Consulta Urgente
                </h3>
                <p className="text-gray-600 mb-4">Respuesta en 12h</p>
                <div className="text-5xl font-bold text-yellow-600 mb-2">
                  135 <span className="text-2xl">USD</span>
                </div>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Todo lo de Consulta Normal</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-flashlight-fill text-xl text-yellow-600 mt-1"></i>
                  <span className="text-gray-700 font-semibold">Respuesta prioritaria en 12h</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-flashlight-fill text-xl text-yellow-600 mt-1"></i>
                  <span className="text-gray-700 font-semibold">Atención preferente</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-flashlight-fill text-xl text-yellow-600 mt-1"></i>
                  <span className="text-gray-700 font-semibold">Seguimiento inmediato</span>
                </li>
              </ul>
              <a 
                href="https://calendly.com/abogado-extranjeria/video-llamada-no-urgente-clon?back=1&month=2025-11" 
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-yellow-500 text-gray-900 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-all text-center whitespace-nowrap cursor-pointer"
              >
                Reservar Urgente
              </a>
            </div>

            <div className="bg-white rounded-2xl shadow-2xl p-8 hover:scale-105 transition-transform">
              <div className="text-center mb-6">
                <div className="w-20 h-20 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                  <i className="ri-global-line text-4xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  Consulta en Inglés
                </h3>
                <p className="text-gray-600 mb-4">English consultation</p>
                <div className="text-5xl font-bold text-green-600 mb-2">
                  225 <span className="text-2xl">USD</span>
                </div>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Full consultation in English</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Eligibility assessment</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Personalized strategy</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Document checklist</span>
                </li>
              </ul>
              <a 
                href="https://calendly.com/abogado-extranjeria/english_consultation?back=1&month=2025-11" 
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-green-600 text-white py-4 rounded-lg font-bold text-lg hover:bg-green-700 transition-all text-center whitespace-nowrap cursor-pointer"
              >
                Book Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}